import { axiosPlatform } from "../../../../_services/axios-helper";
import { Integration } from "../../../../_statics/Integration";

const integrationBase = () => "/integrations" + Integration.ZALANDO.integrationPath;

const testConnection = (clientUUID, credentials) => {
    return axiosPlatform().post(integrationBase() + "/test-connection", credentials, {
        params: { clientUUID },
    });
};

const connect = (createDto) => {
    return axiosPlatform().post(integrationBase() + "/connect", createDto);
};

const disconnect = (clientUUID) => {
    return axiosPlatform().delete(integrationBase() + "/connect/" + encodeURIComponent(clientUUID));
};

const getConfig = (clientUUID) => {
    return axiosPlatform().get(integrationBase() + "/config", {
        params: { clientUUID },
    });
};

const startPreImport = (request) => {
    return axiosPlatform().post(integrationBase() + "/pre-import", request);
};

const startFullImport = (request) => {
    return axiosPlatform().post(integrationBase() + "/full-import", request);
};

export const zalandoService = {
    testConnection,
    connect,
    disconnect,
    getConfig,
    startPreImport,
    startFullImport,
};
